import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useListAdminStaff() {
  const api = useOsApi()

  return useQuery({
    queryKey: ['admin', 'staff'],
    queryFn: async () => {
      const response = await api.get('/admin/staff')
      if (!response.success) throw new Error(response.error.message)
      return response.data.staff
    },
  })
}
